"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledSearchResult = exports.StyledSearchResultsContainer = exports.StyledSearchContainer = exports.StyledButtonsContainer = exports.StyledDivider = exports.StyledDropdown = exports.StyledFolderInput = exports.StyledPublishModal = void 0;
const tslib_1 = require("tslib");
const styled_components_1 = tslib_1.__importDefault(require("styled-components"));
exports.StyledPublishModal = styled_components_1.default.div `
  display: flex;
  width: 410px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: ${({ theme }) => `${theme.Spacing.Size.Small}px`};
`;
exports.StyledFolderInput = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  gap: ${({ theme }) => `${theme.Spacing.Size.XSmall}px`};
`;
exports.StyledDropdown = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  gap: ${({ theme }) => `${theme.Spacing.Size.XSmall}px`};
`;
exports.StyledDivider = styled_components_1.default.div `
  display: flex;
  width: 100%;
  height: 0;
  border-top: 1px solid ${({ theme }) => theme.Color.Neutrals.Light};
`;
exports.StyledButtonsContainer = styled_components_1.default.div `
  display: flex;
  width: 100%;
  justify-content: flex-end;
  align-items: center;
  gap: ${({ theme }) => `${theme.Spacing.Size.Small}px`};
`;
exports.StyledSearchContainer = styled_components_1.default.div `
  display: flex;
  width: 100%;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  gap: ${({ theme }) => `${theme.Spacing.Size.Small}px`};
`;
exports.StyledSearchResultsContainer = styled_components_1.default.div `
  display: flex;
  width: 100%;
  justify-content: flex-start;
  flex-direction: column;
  gap: ${({ theme }) => `${theme.Spacing.Size.Small}px`};
  border-radius: ${({ theme }) => `${theme.Border.Radius.Small}px`};
  border: 1px solid ${({ theme }) => theme.Color.Neutrals.Border};
  padding: ${({ theme }) => `${theme.Spacing.Size.Small}px`};
  max-height: 150px;
  min-height: 150px;
  overflow-y: auto;

  ${({ theme }) => theme.Scrollbar.Default}
`;
exports.StyledSearchResult = styled_components_1.default.div `
  display: flex;
  gap: ${({ theme }) => `${theme.Spacing.Size.Small}px`};
  justify-content: flex-start;
`;
//# sourceMappingURL=CreateFolderModal.style.js.map